import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import { useInternalCategories } from '@gozoki/api';
import { useMemo } from 'react';

export interface CategoryPickerProps {
    setCurrentCategory: (value: number) => void;
}

export const InternalCategoryPicker = ({ setCurrentCategory }: CategoryPickerProps) => {
    const { data: internalCategories } = useInternalCategories();

    const storeSelectOptions = useMemo(() => {
        const options = internalCategories?.map((category) => ({
            label: category.name,
            value: category.id,
        }));
        options?.push({ label: 'Toutes les catégories internes', value: 0 });
        return options;
    }, [internalCategories]);

    return (
        <div style={{ display: 'flex', flex: 2, margin: 6 }}>
            <FormControl fullWidth>
                <InputLabel>Catégories internes</InputLabel>
                <Select
                    label="Catégories internes"
                    defaultValue={0}
                    onChange={(e) => setCurrentCategory(e.target.value as number)}
                >
                    {storeSelectOptions?.map((store) => (
                        <MenuItem key={store.value} value={store.value}>
                            {store.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};
